import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {ServiceRequestService} from '../../services/service-request.service';
import {ServiceRequestComponent} from './service-request.component';
import {ServiceRequestListComponent} from './service-request-list/service-request-list.component';
import {ServiceRequestFilterComponent} from '../../components/service-request-filter/service-request-filter.component';
import {ServiceDetailSectionComponent} from './service-detail-section/service-detail-section.component';
import {FieldsModule} from '../../components/fields/fields.module';
import {ServiceRequestModalComponent} from './service-request-modal/service-request-modal.component';
import {ServiceAddCommentAssignToModalComponent} from './service-add-comment-assign-to-modal/service-add-comment-assign-to-modal.component';
import { VendorSelectComponent } from './vendor-select/vendor-select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        NgSelectModule,
        UtilsModule
    ],
    declarations: [
        ServiceRequestComponent,
        ServiceRequestListComponent,
        ServiceRequestFilterComponent,
        ServiceDetailSectionComponent,
        ServiceRequestModalComponent,
        ServiceAddCommentAssignToModalComponent,
        VendorSelectComponent
    ],
    exports: [
        ServiceRequestModalComponent
    ],
    providers: [
        ServiceRequestService
    ]
})
export class ServiceRequestModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-request.module.ts